/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleCarBattery
 */
export interface VehicleCarBattery {
    /**
     * 
     * @type {Date}
     * @memberof VehicleCarBattery
     */
    time: Date;
    /**
     * 
     * @type {number}
     * @memberof VehicleCarBattery
     */
    volts: number;
}

export function VehicleCarBatteryFromJSON(json: any): VehicleCarBattery {
    return VehicleCarBatteryFromJSONTyped(json, false);
}

export function VehicleCarBatteryFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleCarBattery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'time': (new Date(json['time'])),
        'volts': json['volts'],
    };
}

export function VehicleCarBatteryToJSON(value?: VehicleCarBattery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'time': (value.time.toISOString()),
        'volts': value.volts,
    };
}


